/**
 * vat-excl-pricing.js — Artline Group EU
 *
 * Dedicated module for VAT-excl. markets (International, Europe non-EU)
 * where a market-level autodiscount (custom.vat_autodiscount_rate metafield)
 * strips VAT out of the displayed retail price.
 *
 * Scope: ONLY runs on pages where [data-vat-excl-block] is present —
 * i.e. only for markets that have the vat_autodiscount_rate metafield set.
 * Does NOT touch B2B pricing (b2b-pricing.js) or standard EU retail pricing
 * (b2c-pricing.js handles the gift banner + base retail price update for
 * everyone; this file recalculates on top of that, only in VAT-excl. markets).
 *
 * Responsibilities:
 *  - On variant change, recompute the displayed price/compare/save using the
 *    VAT rate baked into the page (data-vat-rate), matching the same math
 *    server-rendered in snippets/product.price.liquid and variant-button.liquid.
 */

(function ArtlineVatExclPricing() {
  'use strict';

  var block = document.querySelector('[data-vat-excl-block]');
  if (!block) return; // Not a VAT-excl. market — nothing to do.

  var vatRate = parseFloat(block.getAttribute('data-vat-rate')) || 0;
  if (vatRate <= 0) return;

  var vatDiscountMultiplier = 1 - (vatRate / 100);

  // ─── Money formatting (mirrors b2c-pricing.js fallback) ───────────────────────
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      var fmt = (window.theme.settings && window.theme.settings.moneyFormat) || '&euro;{{amount}}';
      return window.theme.Currency.formatMoney(cents, fmt);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20ac' + amount;
  }

  // ─── Price recompute ──────────────────────────────────────────────────────────
  function updateVatExclPrice(variant) {
    if (!variant) return;

    var currentBlock = document.querySelector('[data-vat-excl-block]');
    if (!currentBlock) return;

    var price = variant.price;
    var compareAt = variant.compare_at_price;
    var hasSale = compareAt && compareAt > price;

    var priceExclVat = Math.round(price * vatDiscountMultiplier);
    var compareExclVat = hasSale ? Math.round(compareAt * vatDiscountMultiplier) : null;

    var row = currentBlock.querySelector('.artline-price__row');
    if (!row) return;

    if (hasSale) {
      var savedCents = compareExclVat - priceExclVat;
      row.innerHTML =
        '<span class="artline-price__main artline-price__main--sale" data-excl-price>' + formatMoney(priceExclVat) + '</span>' +
        '<span class="artline-price__compare" data-excl-compare>' + formatMoney(compareExclVat) + '</span>' +
        '<span class="artline-price__save" data-excl-save>Save ' + formatMoney(savedCents) + '</span>';
    } else {
      row.innerHTML =
        '<span class="artline-price__main" data-excl-price>' + formatMoney(priceExclVat) + '</span>';
    }
  }

  // ─── Listeners ───────────────────────────────────────────────────────────────
  function bindListeners() {
    document.addEventListener('variant:change', function (e) {
      updateVatExclPrice(e.detail && e.detail.variant);
    });
    document.addEventListener('variantChange', function (e) {
      updateVatExclPrice(e.detail && e.detail.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindListeners);
  } else {
    bindListeners();
  }

  window.ArtlineVatExclPricing = { updateVatExclPrice: updateVatExclPrice };
})();
